module.exports = __webpack_public_path__ + "bin/b22d464c204a552757202c3ad27021ba.png";